const REDIRECTS_MAP: Record<string, string> = {
  "liveauction.psg.fr":
    "https://www.matchwornshirt.com/category/paris-saint-germain",
  "matchwornshirt.juventus.com":
    "https://www.matchwornshirt.com/category/juventus",
  "maillots-portes.om.fr":
    "https://www.matchwornshirt.com/category/olympique-marseille",
  "matchwornshirt.psv.nl": "https://www.matchwornshirt.com/category/psv",
};

export default defineNuxtPlugin({
  name: "whitelabelRedirects",
  setup: async () => {
    const host = discoverHost();
    const redirectTo = REDIRECTS_MAP[host];

    if (!redirectTo) return;

    navigateTo(redirectTo, {
      redirectCode: 302,
      external: true,
    });
  },
});
